import { render, staticRenderFns } from "./KkiapayVerificationModal.vue?vue&type=template&id=bd4efdfe"
import script from "./KkiapayVerificationModal.vue?vue&type=script&lang=ts"
export * from "./KkiapayVerificationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports